export function newsletterFooter() {
  const newsletterForm: HTMLFormElement | null = document.querySelector('.js-newsletter-form');
  const formPage1 = document.querySelector('.js-newsletter-page-1');
  const formPage2 = document.querySelector('.js-newsletter-page-2');
  const firstName = document.querySelector('.js-newsletter-firstName');
  const lastName = document.querySelector('.js-newsletter-lastName');
  const acceptTerms = document.querySelector('.js-newsletter-acceptTerms');
  const nextButton = document.querySelector('.js-newsletter-next');
  const backButton = document.querySelector('.js-newsletter-back');

  if (formPage1 && formPage2 && nextButton && backButton) {
    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (newsletterForm) {
        if (!newsletterForm.checkValidity()) {
          const tmpSubmit = document.createElement('button');
          newsletterForm.appendChild(tmpSubmit);
          tmpSubmit.click();
          newsletterForm.removeChild(tmpSubmit);
        } else {
          if (formPage1.classList.contains('newsletterForm--show')) {
            formPage1.classList.remove('newsletterForm--show');
            formPage2.classList.add('newsletterForm--show');
            formPage2?.querySelector('input')?.focus();
            firstName?.setAttribute('required', 'required');
            lastName?.setAttribute('required', 'required');
            acceptTerms?.setAttribute('required', 'required');
          }
        }
      }
    });

    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      formPage1.classList.add('newsletterForm--show');
      formPage2.classList.remove('newsletterForm--show');
      formPage1?.querySelector('input')?.focus();
      firstName?.removeAttribute('required');
      lastName?.removeAttribute('required');
      acceptTerms?.removeAttribute('required');
    });
  }
}
